// extracted by mini-css-extract-plugin
export default {"btnSearch":"reports_btnSearch__Wqz8u"};